import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { useNavigationConditional } from '@wix/gg-components';
import { useIsLoggedIn, useRedirectHandler } from 'hooks';
import { StepId } from 'config/steps';

interface UseProtectedNavigationConfig {
  returnToStepId: StepId;
}

export function useProtectedNavigation(config: UseProtectedNavigationConfig) {
  const { next } = useOrchestratorNavigation();
  const isLoggedIn = useIsLoggedIn();
  const { handleRedirect } = useRedirectHandler({ returnToStepId: config.returnToStepId });

  return useNavigationConditional({
    condition: isLoggedIn,
    onConditionMet: next,
    onConditionNotMet: handleRedirect,
  });
}
